const fr = {
  fr: {
    translation: {
      document: {
        attachment: 'Pièce jointe : ',
        cc: 'Cc : ',
        email_account: 'Compte : ',
        email_ref: 'Email de référence : ',
        folder: 'Dossier : ',
        from: 'De : ',
        id: 'Id : ',
        language: 'Langue : ',
        message_id: 'Id de Message : ',
        mime: 'Mime : ',
        modified_user: 'Modifié par : ',
        reception_date: 'Date de réception : ',
        scope: 'Scope : ',
        send_date: 'Date d\'envoi : ',
        to: 'À : ',
        type_document: {
          attachment: 'Pièce jointe',
          email: 'E-mail',
          libelle: 'Type de document : ',
        },
        type_scope: {
          back_up: 'Back-up',
          irrelevant: 'Non pertinent',
          other: 'Autre',
          personnal: 'Personnel',
          relevant: 'Pertinent',
          unexploited: 'Non exploité',
          very_relevant: 'Très pertinent',
        },
      },
    },
  },
};

export default fr;
